import styled from '@emotion/styled';
import { Card, CardPalette, Text } from '@updater/ui-uds';
import { CallRailPhone } from 'components/CallRailPhone';
import { ComponentProps, FC } from 'react';

const InfoCard = styled(Card)(
  ({ theme }) => `
  padding: ${theme.space.m}px;
`
);

export const CallCenterInfo: FC<ComponentProps<typeof Card>> = (props) => (
  <InfoCard
    backgroundColor={CardPalette.gray96}
    border={0}
    data-testid="call-center-info"
    {...props}
  >
    <Text variant="lBold" data-testid="call-center-info-heading">
      Question?
    </Text>
    <Text variant="s" mt="xxs" data-testid="call-center-info-body">
      Call us at <CallRailPhone text="###" variant="inherit" />. Our specialists
      are available now to assist you.
    </Text>
  </InfoCard>
);
